<template>
    <SchedulerSettings></SchedulerSettings>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const SchedulerSettings = defineAsyncComponent(() =>
    import("../../components/Design/SchedulerSettings.vue")
);

export default {
    name: "SchedulerSettingsPage", //The name you are in should not equal the name of the component you are importing.
    components: { SchedulerSettings, AuthLayout },
};
</script>
